import { render } from "./ComboNoticia.vue?vue&type=template&id=66980dbc&scoped=true"
import script from "./ComboNoticia.vue?vue&type=script&lang=js"
export * from "./ComboNoticia.vue?vue&type=script&lang=js"

import "./ComboNoticia.vue?vue&type=style&index=0&id=66980dbc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66980dbc"]])

export default __exports__